import * as React from "react"
import {TableCell} from "@mui/material";
import PriceDiscountPriceBlock from "../../../../../../@components/PriceBlock";


export default function PricingPriceCell({ price, currency, diff, retailer }) {
    return <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
        <PriceDiscountPriceBlock
            price={price}
            currency={currency}
            diff={diff}
            retailer={retailer}
            reverse={true}
        />
    </TableCell>
}